export const ConvertArray = (arr) => {
    var object = [];

    arr.map((issue, idx) => {
        object[idx] = issue[0]

    })
    return object;

};